import styles from "./Users.module.css";
import { useSnackbar } from "notistack";
import { SpeedDial } from "@mui/material";
import Icon from "@mdi/react";
import { mdiAccountPlusOutline } from "@mdi/js";

//react
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

// components
import UsersTable from "./UsersTable";
import Loader from "components/Loader";

// services
import Services from "tools/Services";

export default function Users() {
	const [users, setUsers] = useState([]);
	const [loading, setLoading] = useState(true);
	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		loadUsers();
	}, []);

	const loadUsers = async () => {
		// GET
		let res = await Services.get("/User/getUsers");

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			return;
		}

		// SUCCES
		setUsers(res.data);
		setLoading(false);
	};

	const updateUsers = async (newUser) => {
		// PUT
		let res = await Services.put("/User", newUser);

		// ERROR
		if (res.status !== 200) {
			enqueueSnackbar("Error", {
				variant: "error",
			});
			console.error(res);
			return;
		}

		// SUCCES
		setUsers(res.data);

		enqueueSnackbar("Changes saved", {
			variant: "success",
		});
	};

	const handleDelete = async (id) => {
		// DELETE
		let res = await Services.delete("/User/" + id);

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			enqueueSnackbar(res.error, {
				variant: "error",
			});
			return;
		}

		// SUCCESS
		setUsers(users.filter((user) => user.id !== id));
		enqueueSnackbar("User deleted", {
			variant: "success",
		});
	};

	return (
		<>
			{loading ? <Loader /> : <UsersTable users={users} updateUsers={updateUsers} handleDelete={handleDelete} />}
			<NavLink to={{ pathname: `/users/new` }}>
				<SpeedDial
					ariaLabel="SpeedDial"
					sx={{ position: "fixed", bottom: 40, right: 16 }}
					icon={<Icon path={mdiAccountPlusOutline} size={1} />}
				></SpeedDial>
			</NavLink>
		</>
	);
}
